// src/components/leader/TextField.js - labelled form field with a visible border,
// hint and error text (audit FL-15, FL-28, FL-37). The input uses 16 px text on
// phones so iOS does not zoom in on focus. Fields are required unless the label
// says "(nepovinné)".
import React, { forwardRef, useId } from 'react';

export const inputClasses = (hasError) =>
  `mt-1 block w-full rounded-md border px-3 py-2 text-base shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-100 sm:text-sm ${
    hasError ? 'border-red-500' : 'border-gray-300'
  }`;

const TextField = forwardRef(function TextField(
  { id, label, hint, error, className = '', as = 'input', children, required, ...props },
  ref
) {
  const autoId = useId();
  const fieldId = id || autoId;
  const hintId = hint ? `${fieldId}-hint` : null;
  const errorId = error ? `${fieldId}-error` : null;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;
  const Component = as;
  return (
    <div className={className}>
      <label htmlFor={fieldId} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <Component
        ref={ref}
        id={fieldId}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={inputClasses(Boolean(error))}
        {...props}
      >
        {children}
      </Component>
      {hint && (
        <p id={hintId} className="mt-1 text-xs text-gray-600">
          {hint}
        </p>
      )}
      {error && (
        <p id={errorId} className="mt-1 text-sm text-red-700">
          {error}
        </p>
      )}
    </div>
  );
});

export default TextField;
